import { useState } from "react";

import ExplainPanel from "./explain-panel";
import type { ExplainMetric, CohortDimension } from "./explain-panel";

// A drop-in "Explain" affordance for a metric card: opens the disclosed-calculation
// panel for `metric`, where every bank-derived input drills to its transactions. For a
// retention metric, pass dimension+value to scope the cohort to one /explore segment.
export default function ExplainButton({
  metric,
  title,
  month,
  dimension,
  value,
  label = "Explain",
}: {
  metric: ExplainMetric;
  title: string;
  month?: string | null;
  dimension?: CohortDimension | null;
  value?: string | null;
  label?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Explain this number — show the formula and the inputs behind it"
        className="inline-flex items-center gap-1 rounded border border-gray-200 px-1.5 py-0.5 text-[10px] font-medium text-gray-500 hover:border-emerald-300 hover:bg-emerald-50 hover:text-emerald-700"
      >
        <span aria-hidden className="font-serif italic">ƒ</span>
        {label}
      </button>
      {open && (
        <ExplainPanel
          metric={metric}
          title={title}
          month={month}
          dimension={dimension}
          value={value}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
